import PropTypes from 'prop-types';
import React from 'react';

var humanCount = ['zero', 'one', 'two', 'three', 'four', 'five', 'six'];

class Matrix extends React.Component {
    getAttributes() {
        return {
            className: this.getClassNames(),
            'data-staggered': this.props.staggered,
        };
    }

    getClassNames() {
        let classes = ['matrix'];

        // Build up a collection of classes in `matrix--of-two-small` format
        ['small', 'medium', 'normal', 'large'].forEach(size => {
            var count = humanCount[this.props[size]];
            classes.push(`matrix--of-${count}-${size}`);
        });

        classes.push(this.props.variations);

        return classes.join(' ');
    }

    render() {
        return <div {...this.getAttributes()}>{this.props.children}</div>;
    }
}

Matrix.propTypes = {
    children: PropTypes.node,
    staggered: PropTypes.bool,
    large: PropTypes.number,
    normal: PropTypes.number,
    medium: PropTypes.number,
    small: PropTypes.number,
    variations: PropTypes.array,
};

Matrix.defaultProps = {
    large: 4,
    normal: 3,
    medium: 3,
    small: 2,
    staggered: false,
    variations: [],
};

class MatrixItem extends React.Component {
    render() {
        return <div className="matrix__item">{this.props.children}</div>;
    }
}

MatrixItem.propTypes = {
    children: PropTypes.node.isRequired,
};

export { Matrix, MatrixItem };



// WEBPACK FOOTER //
// ./src/web/js/contest/components/matrix.jsx